import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  max-width: 725px;
  margin: 0 auto;

  margin-top: 35px;

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1rem;
`

export const Mood = styled.div`
  display: grid;
  align-items: center;
  cursor: pointer;

  :hover {
    img {
      transform: scale(.9)
    }
  }
  
  img {
    margin: 0 auto;
    width: 100%;
    transition: all 300ms;
  }
`